import Vue from 'vue'

export const hausefulUsersList = [
  {
    text: Vue.i18n.translate('hausefulUsers.label.name'),
    value: 'name',
    width: 300,
  },
  {
    text: Vue.i18n.translate('hausefulUsers.label.email'),
    value: 'username',
    width: 400,
  },
  {
    text: Vue.i18n.translate('hausefulUsers.label.type'),
    value: 'type',
    width: 200,
  },
  {
    text: Vue.i18n.translate('hausefulUsers.label.realEstate'),
    value: 'real_estate_name',
    width: 200,
  },
  {
    text: Vue.i18n.translate('hausefulUsers.label.integration'),
    value: 'id',
    width: 100,
  },
  {
    value: 'actions',
    align: 'center',
    width: 50,
  },
]
